import { render, staticRenderFns } from "./KioskConfirm.vue?vue&type=template&id=71476396&scoped=true"
import script from "./KioskConfirm.vue?vue&type=script&lang=js"
export * from "./KioskConfirm.vue?vue&type=script&lang=js"
import style0 from "./KioskConfirm.vue?vue&type=style&index=0&id=71476396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71476396",
  null
  
)

export default component.exports